<script>
import { mapActions, mapGetters } from 'vuex';
import {getReissues} from "@/api/reissue";
import { pages } from '@/entities/current-page';
import Pagination from '@/components/Pagination';
import RowBlockSkeleton from "@/views/reissue/components/RowBlockSkeleton";
import displaySettings from "@/mixin/displaySettings";
import Breadcrumbs from "@/shared/ui/breadcrumbs/breadcrumbs/index.vue";
import { PageTitle } from '@/shared/ui/page-title';

export default {
	name: "index",
	components: {RowBlockSkeleton, Pagination, Breadcrumbs, PageTitle },
	mixins: [displaySettings],
	data() {
		return {
			data: [],
			meta: {},
			loading: false,
      breadcrumbs: [
        {
          title: 'Головна',
        },
        {
          title: 'Запити на переоформлення',
        },
      ],
		}
	},
  created() {
    this.changeActivePage(pages.ORDERS);
  },
	methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
		getData() {
			this.loading = true;
			getReissues().then(response => {
				this.data = response.data.data;
				this.meta = response.data.meta
				this.loading = false;
			})
		},
		getStatusName(type) {
			switch (type) {
				case 'pending':
					return 'Очікує подання';
				case 'in_work':
					return 'В роботі'
				case 'reissued':
					return 'Переоформлений'
				case 'rejected':
					return 'Відхилений'
				default:
					return '';
			}
		},
	},
	mounted() {
		this.getData();
	}
}
</script>

<template>
	<div class="reissue-page">
    <PageTitle class="page-title">Запити на переоформлення</PageTitle>
    <Breadcrumbs :breadcrumbs="breadcrumbs"/>
		<div v-if="isMobile">
      <div class="mobile-reissue-orders">

        <div v-for="item in data" :key="item.id" class="mobile-reissue-list-item">
          <div class="row order-data">
            <div class="row-mobile first-row">
              <div class="col-6 half-block">
                <div class="info-block">
                  <div class="option-title">Тип поліса</div>
                  <div class="option-value">{{ item.order.typeName }} Переоформлення</div>
                </div>
              </div>
              <div class="col-6 half-block">
                <div class="info-block">
                  <div class="option-title">Номер поліса</div>
                  <div class="option-value mtsbu-value">
                    <el-link :href="item.order.mtsbuLink" :underline="false" target="_blank">
                      {{ item.order.policyNumber }}
                    </el-link>
                    <div v-if="item.result && item.result.newMtsbyCode">змінено на</div>
                    <div class="option-value" v-if="item.result && item.result.newMtsbyCode">
                      {{ item.result.newMtsbyCode }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row-mobile first-row">
              <div class="col-6 half-block">
                <div class="info-block">
                  <div class="option-title">Дата</div>
                  <div class="sub-options">
                    <div>
                      <span class="sub-option-title">Дата запиту:</span>
                      <span class="option-value">{{ item.createdAt }}</span>
                    </div>
                    <div>
                      <span class="sub-option-title">Дата полісу:</span>
                      <span class="option-value">{{ item.order.createdAt }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6 half-block">
                <div class="info-block">
                  <div class="option-title">Страхувальник</div>
                  <div class="sub-options">
                    <div>
                      <span class="option-value name-wrap">{{ item.order.insuredPersonOwner.fullName }}</span>
                    </div>
                  </div>
<!--                  <div class="option-value">-->
<!--                    {{ item.order.insuredPersonOwner.fullName }}-->
<!--                  </div>-->
                </div>
              </div>
            </div>

            <div class="row-mobile first-row">
              <div class="col-6 half-block" v-if="item.data !== null">
                <div class="info-block">
                  <div class="option-title">Деталі</div>
                  <div class="sub-options">
                    <div v-if="item.data.file">
<!--                      <span class="sub-option-title">Запит створено:</span>-->
                      <span class="option-value">
                        <div v-if="Array.isArray(item.data.file)">
                          <el-link v-for="(f, idx) in item.data.file" :key="idx" :href="(item.data.fileUrls && item.data.fileUrls[idx]) ? item.data.fileUrls[idx] : ('/storage/' + f)" target="_blank" :underline="false" style="margin-right: 5px;">
                            <span class="icon">
                              <svg style="margin-bottom: 5px;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10" stroke="#24282C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M4.6665 6.66666L7.99984 9.99999L11.3332 6.66666" stroke="#24282C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M8 10V2" stroke="#24282C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                            <span class="option-value" style="margin-left: 3px; text-decoration: underline;">Заява {{ idx + 1 }}</span>
                          </el-link>
                        </div>
                        <el-link v-else :href="item.data.fileUrl ? item.data.fileUrl : ('/storage/' + item.data.file)" target="_blank" :underline="false">
                          <span class="icon">
                            <svg style="margin-bottom: 5px;" width="16" height="16"
                                 viewBox="0 0 16 16" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                      d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
                                                      stroke="#24282C" stroke-width="2"
                                                      stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path
                                                      d="M4.6665 6.66666L7.99984 9.99999L11.3332 6.66666"
                                                      stroke="#24282C" stroke-width="2"
                                                      stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8 10V2" stroke="#24282C" stroke-width="2"
                                                          stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                          </span>
                          <span class="option-value" style="margin-left: 3px; text-decoration: underline;">Заява</span>
                        </el-link>
                      </span>

                    </div>
                    <div v-if="item.data.email">
                      <span class="sub-option-title">Email:</span>
                      <span class="option-value">{{ item.data.email }}</span>
                    </div>
                    <div v-if="item.data.reason">
                      <span class="sub-option-title">Причина:</span>
                      <span class="option-value">{{ item.data.reason }}</span>
                    </div>
                    <div v-if="item.data.numberPolicy">
                      <span class="sub-option-title">Номер нового полісу:</span>
                      <span class="option-value">{{ item.data.numberPolicy }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6 half-block">
                <div class="info-block">
                  <div class="option-title">Вартість полісу, грн</div>
                  <div class="sub-options">
                    <div>
                      <span class="option-value">{{ item.order.price }} грн</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row-mobile first-row">
              <div class="col-6 half-block">
                <div class="info-block">
                  <div class="option-title">Статус:</div>
                  <div class="option-value">
                    <div :class="['status', `status-${item.status}`]">
                      <span>{{ getStatusName(item.status) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6 half-block">
                <div class="info-block">
                  <div class="option-title">Додатково</div>
                  <div class="sub-options" v-if="item.result !== null">
                    <div v-if="item.result.newContract">
                      <span class="option-value">
                        <el-link :href="item.result.newContractUrl || ('/storage/' + item.result.newContract)" target="_blank" :underline="false">
                          <span class="icon">
                            <svg style="margin-bottom: 5px;" width="16" height="16"
                                 viewBox="0 0 16 16" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                      d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
                                                      stroke="#24282C" stroke-width="2"
                                                      stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path
                                                      d="M4.6665 6.66666L7.99984 9.99999L11.3332 6.66666"
                                                      stroke="#24282C" stroke-width="2"
                                                      stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8 10V2" stroke="#24282C" stroke-width="2"
                                                          stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                          </span>
                          <span class="option-value" style="margin-left: 3px; text-decoration: underline;">Новий договір</span>
                        </el-link>
                      </span>
                    </div>
                    <div v-if="item.result.newMtsbyCode">
                      <span class="sub-option-title">Новий МТСБУ код:</span>
                      <span class="option-value">{{ item.result.newMtsbyCode }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


<!--			<el-collapse :accordion="true">-->
<!--				<el-collapse-item v-for="item in data" :key="item.id">-->
<!--					<template #title>-->
<!--						<div class="w-100">-->
<!--							<el-row align="middle">-->
<!--								<el-col :span="12">-->
<!--									<div><b>Тип статусу</b></div>-->
<!--									<div>-->
<!--										{{ item.order.typeName }} Переоформлення-->
<!--									</div>-->
<!--								</el-col>-->
<!--								<el-col :span="12">-->
<!--									<div>-->
<!--										<b>Номер поліса</b>-->
<!--									</div>-->
<!--									<el-link :href="item.order.mtsbuLink" :underline="false" target="_blank">{{-->
<!--											item.order.policyNumber-->
<!--										}}-->
<!--									</el-link>-->
<!--								</el-col>-->
<!--							</el-row>-->
<!--						</div>-->
<!--					</template>-->
<!--					<div>-->
<!--						<el-row :gutter="5">-->
<!--							<el-col>-->
<!--								<el-row>-->
<!--									<el-col>-->
<!--										<b>Дата</b>-->
<!--									</el-col>-->
<!--									<el-col>-->
<!--										<span>Запит створений:</span>-->
<!--										{{ item.createdAt }}-->
<!--									</el-col>-->
<!--									<el-col>-->
<!--										<span>Поліс створений:</span>-->
<!--										{{ item.order.createdAt }}-->
<!--									</el-col>-->
<!--								</el-row>-->
<!--							</el-col>-->
<!--							<el-col>-->
<!--								<el-row>-->
<!--									<el-col><b>Страхувальник</b></el-col>-->
<!--									<el-col>-->
<!--										<el-col>-->
<!--											{{ item.order.insuredPersonOwner.fullName }}-->
<!--										</el-col>-->
<!--										<el-col v-if="item.data !== null">-->
<!--											<el-col v-if="item.data.file">-->
<!--												<el-link :href="'/storage/' + item.data.file" target="_blank" :underline="false">Заява</el-link>-->
<!--											</el-col>-->
<!--											<el-col v-if="item.data.email">-->
<!--												Email: {{ item.data.email }}-->
<!--											</el-col>-->
<!--											<el-col v-if="item.data.reason">-->
<!--												Причина: {{ item.data.reason }}-->
<!--											</el-col>-->
<!--											<el-col v-if="item.data.numberPolicy">-->
<!--												Номер нового полісу: {{ item.data.numberPolicy }}-->
<!--											</el-col>-->
<!--										</el-col>-->
<!--									</el-col>-->
<!--								</el-row>-->
<!--							</el-col>-->
<!--							<el-col>-->
<!--								<el-row>-->
<!--									<el-col><b>Вартість полісу, грн</b></el-col>-->
<!--									<el-col>{{ item.order.price }} грн</el-col>-->
<!--								</el-row>-->
<!--							</el-col>-->
<!--              <el-col>-->
<!--                <el-row>-->
<!--                                    <el-col><b>Деталі</b></el-col>-->
<!--                                    <el-col v-if="item.result !== null">-->
<!--                                        <el-col v-if="item.result.newContract">-->
<!--                                            <el-link :href="'/storage/' + item.result.newContract" target="_blank" :underline="false">Новий файл договору</el-link>-->
<!--                                        </el-col>-->
<!--                                        <el-col v-if="item.result.newMtsbyCode">-->
<!--                                            Новий МТСБУ код: {{ item.result.newMtsbyCode }}-->
<!--                                        </el-col>-->
<!--                                    </el-col>-->
<!--                                </el-row>-->
<!--              </el-col>-->
<!--						</el-row>-->
<!--					</div>-->
<!--				</el-collapse-item>-->
<!--			</el-collapse>-->
		</div>

		<div v-else class="list-reissue">
      <div class="container-wrapp">
        <div class="header-block">
          <ul class="columns-block">
            <li class="column">Тип статусу</li>
            <li class="column">Номер поліса</li>
            <li class="column">Дата</li>
            <li class="column">Страхувальник</li>
            <li class="column">Вартість полісу, грн</li>
            <li class="column">Деталі</li>
          </ul>
        </div>
        <div v-if="loading">
          <row-block-skeleton v-for="item in 4" :key="item"/>
        </div>
        <div v-else>
          <div class="row-block" v-for="item in data">
            <ul class="columns-block">
              <li class="column">
                <el-col>
                  <div class="option-result">{{ item.order.typeName }}</div> Переоформлення
                </el-col>
                <el-col class="right-border">
                  <div class="d-flex align-middle">
                    <div>
                      <span>Статус:</span>
                    </div>
                    <div :class="['status', `status-${item.status}`]">
                      <span>{{ getStatusName(item.status) }}</span>
                    </div>
                  </div>
                </el-col>
              </li>
              <li class="column">
                <el-col>
                  <el-link :href="item.order.mtsbuLink" :underline="false" target="_blank">
                    <div class="option-result">{{ item.order.policyNumber }}</div>
                  </el-link>
                  <div v-if="item.result && item.result.newMtsbyCode">змінено на</div>
                  <div class="option-result" v-if="item.result && item.result.newMtsbyCode">
                    {{ item.result.newMtsbyCode }}
                  </div>
                </el-col>
                <!--                            <el-col>-->
                <!--                                <div>змінено на</div>-->
                <!--                                <el-link :href="item.order.mtsbuLink" :underline="false" target="_blank">{{-->
                <!--                                        item.order.policyNumber-->
                <!--                                    }}-->
                <!--                                </el-link>-->
                <!--                            </el-col>-->
                <el-col class="right-border">
                  <div class="option">Точка продажу</div>
                  <div class="option-result">
                    {{ item.order.user.fullName }}
                  </div>
                </el-col>
              </li>
              <li class="column">
                <el-row>
                  <el-col>
                    <span class="option">Запит створений:</span>
                    <span class="option-result">{{ item.createdAt }}</span>
                  </el-col>
                  <el-col>
                    <span class="option">Поліс створений:</span>
                    <span class="option-result">{{ item.order.createdAt }}</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="right-border">
                    <div class="option">СК:</div>
                    <span class="option-result">{{ item.order.companyName }}</span>
                  </el-col>
                </el-row>
              </li>
              <li class="column">
                <el-row>
                  <el-col>
                    <span class="option-result">{{ item.order.insuredPersonOwner.fullName }}</span>
                  </el-col>
                  <el-col v-if="item.data !== null">
                    <el-col v-if="item.data.file">
                      <div v-if="Array.isArray(item.data.file)">
                        <el-link v-for="(f, idx) in item.data.file" :key="idx" :href="(item.data.fileUrls && item.data.fileUrls[idx]) ? item.data.fileUrls[idx] : ('/storage/' + f)" target="_blank" :underline="false" style="margin-right: 5px;">
                          <span class="icon">
                            <svg style="margin-bottom: 5px;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10" stroke="#24282C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M4.6665 6.66666L7.99984 9.99999L11.3332 6.66666" stroke="#24282C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8 10V2" stroke="#24282C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                          <span class="option-result" style="margin-left: 3px; text-decoration: underline;">Заява {{ idx + 1 }}</span>
                        </el-link>
                      </div>
                      <el-link v-else :href="item.data.fileUrl ? item.data.fileUrl : ('/storage/' + item.data.file)" target="_blank" :underline="false">
                        <span class="icon">
                          <svg style="margin-bottom: 5px;" width="16" height="16"
                               viewBox="0 0 16 16" fill="none"
                               xmlns="http://www.w3.org/2000/svg">
                                                  <path
                                                    d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
                                                    stroke="#24282C" stroke-width="2"
                                                    stroke-linecap="round" stroke-linejoin="round"/>
                                                  <path
                                                    d="M4.6665 6.66666L7.99984 9.99999L11.3332 6.66666"
                                                    stroke="#24282C" stroke-width="2"
                                                    stroke-linecap="round" stroke-linejoin="round"/>
                                                  <path d="M8 10V2" stroke="#24282C" stroke-width="2"
                                                        stroke-linecap="round" stroke-linejoin="round"/>
                                              </svg>
                        </span>
                        <span class="option-result" style="margin-left: 3px; text-decoration: underline;">Заява</span>
                      </el-link>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col v-if="item.data !== null">
                    <el-col v-if="item.data.email">
                      <span class="option">Email:</span>
                      <span class="option-result">{{ item.data.email }}</span>
                    </el-col>
                    <el-col v-if="item.data.reasonType">
                      <span class="option">Причина:</span>
                      <span class="option-result">{{ item.data.reasonTypeName }}</span>
                    </el-col>
                    <el-col v-if="item.data.reason">
                      <span class="option">Змінено на: </span>
                      <span class="option-result">{{ item.data.reason }}</span>
                    </el-col>
                    <el-col v-if="item.data.numberPolicy">
                      <span class="option">Номер нового полісу:</span>
                      <span class="option-result">{{ item.data.numberPolicy }}</span>
                    </el-col>
                  </el-col>
                </el-row>
              </li>
              <li class="column">
                <span class="option-result">{{ item.order.price }} грн</span>
              </li>
              <li class="column">
                <el-col v-if="item.result !== null">
                  <el-col v-if="item.result.newContract">
                    <el-link :href="item.result.newContractUrl || ('/storage/' + item.result.newContract)" target="_blank" :underline="false" >
                      <span class="icon">
                        <svg style="margin-bottom: 5px;" width="16" height="16"
                                                 viewBox="0 0 16 16" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                  d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
                                                  stroke="#24282C" stroke-width="2"
                                                  stroke-linecap="round" stroke-linejoin="round"/>
                                                <path
                                                  d="M4.6665 6.66666L7.99984 9.99999L11.3332 6.66666"
                                                  stroke="#24282C" stroke-width="2"
                                                  stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8 10V2" stroke="#24282C" stroke-width="2"
                                                      stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                      </span>
                      <span class="option-result" style="margin-left: 3px; text-decoration: underline;">Новий договір</span>
                    </el-link>
                  </el-col>
                  <el-col v-if="item.result.newMtsbyCode">
                    Новий МТСБУ: {{ item.result.newMtsbyCode }}
                  </el-col>
                  <el-col v-if="item.result.rejectionReason">
                    Причина відхилення:
                    <div>{{ item.result.rejectionReason }}</div>
                  </el-col>
                </el-col>
              </li>
            </ul>
          </div>
        </div>
      </div>
		</div>

    <div style="text-align: center" class="pagination-block reissue-pagination">
      <pagination v-if="meta.total > 0"
                  :total="meta.total"
                  :page.sync="meta.current_page"
                  :limit.sync="meta.per_page"
                  @pagination="getData()"
                  class="text-center"
      />
    </div>
	</div>
</template>

<style lang="scss">
@import "./styles/list";
</style>
<style scoped>
* >>> .el-collapse-item__header {
	height: auto;
	line-height: unset;
	&:nth-child(2n+1) {
		background: #F6F7FB;
	}
}
.page-title {
  font-size: 30px;
  line-height: 44px;
  color: #24282c;
  font-weight: 700;
//margin-bottom: 26px !important;
}
span {
	color:#999DA6;
}
</style>
